import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Rating,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import CustomEmojiPicker from "./customemojipicker";

const FeedBackForm = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const [brandUrl,setBrandUrl] = useState('')
  const [formExist,setFormExist] = useState(false)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
//   console.log(searchParams.get("brand"));
//   console.log(searchParams.get("subzone"));
//   console.log(searchParams.get("guid"));
//   console.log(searchParams.get("id"));

  // useEffect(())

  const [formData, setFormData] = useState({
    reviewer_name: "",
    contact: "",
    user_email: "",
    review: "",
    rating: 0, // Added rating state
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
console.log(decodeURIComponent(searchParams.get("brand")))
  const handleRatingChange = (event, newValue) => {
    // console.log(newValue);
    setFormData({
      ...formData,
      rating: newValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    if (formData.rating === 0) {
      // Handle the case where rating is not provided
      alert('Please provide a rating.');
      return;
    }
  
    const brand = searchParams.get("brand");
    const brandData = {
      restaurant_name: brand? decodeURIComponent(brand).trim():'',
      sub_zone: searchParams.get("subzone"),
      id: searchParams.get("id"),
      review_date : new Date().toISOString(),
      orderType:'dinner',
      mealTime:'others'
    };
    const newformData = { ...formData, ...brandData };
    console.log("Form submitted:", newformData);
    const url = "https://madara-api.restaverse.com/api/automation/insert-feedback-form-data"
    const response = await fetch(url,{ 
        method: "POST",
        body:JSON.stringify(newformData),
        headers:{'Content-Type':'application/json',}
    });

    if (!response.ok) {
        // throw new Error(`HTTP error! status: ${response.status}`);
        console.log("something went wrong")

    }
    setFormData({
        reviewer_name: "",
        contact: "",
        user_email: "",
        review: "",
        rating: 0, // Added rating state
      })


    // Handle form submission logic here
  };

  useEffect(()=>{

    const isFormValid = async () =>{
    const formGuid = searchParams.get("guid")
    const response = await fetch(`https://madara-api.restaverse.com/api/automation/check-form-exist?guid=${formGuid}`);
    const parsedResponse = await response.json();
    const logo = parsedResponse?.brand_logo || ''; 
    setBrandUrl(logo)
    // console.log(logo)
    // console.log(response.ok)
    // const h = await response.json()
    // console.log(h)
    if(response.ok){
        setFormExist(true)
    }
    }
    isFormValid()
  },[])

  return (
    <Box
    sx={{
      display: "flex",
      flexDirection: "column", // Ensure vertical stacking
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "#F6F6F6",
    }}
  >
    <img src={brandUrl} alt="Brand Logo" width={'50px'} style={{ marginBottom: '10px', marginTop:'10px' }} />
    <Card
      sx={{
        maxWidth: 600,
        width: "100%",
        padding: 3,
        borderRadius: 2,
        boxShadow: "10px 10px #FFB22A", // Custom shadow with gold color
      }}
    >
      <CardContent>
        <Typography variant="h4" gutterBottom>
          ✨ We'd love to hear from you
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          Hey there! You‘re here because you‘re an awesome Magnolia Bakery
          customer! 👏We’d love to receive your feedback so that we can
          improve.
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2, // Adds spacing between form elements
            alignItems: "stretch", // Ensures the form takes up the full width
          }}
        >
          <TextField
            label="Your Name"
            name="reviewer_name"
            required
            value={formData.reviewer_name}
            onChange={handleChange}
            fullWidth
            margin="normal"
            placeholder="Enter your name"
          />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Your Phone Number"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                fullWidth
                margin="normal"
                placeholder="Enter your phone number"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Your Email ID"
                name="user_email"
                type="email"
                value={formData.user_email}
                onChange={handleChange}
                fullWidth
                margin="normal"
                placeholder="Enter your email ID"
              />
            </Grid>
          </Grid>
          {/* Rating Component */}
          <Box sx={{ marginTop: 2 }}>
            <Typography variant="h6">Rating</Typography>
            <Rating
              name="rating"
              required
              value={formData.rating}
              onChange={handleRatingChange}
              // precision={0.5}
              sx={{
                "& .MuiRating-iconFilled": {
                  color: "#FFB229", // Set the color for filled stars
                },
                "& .MuiRating-iconEmpty": {
                  color: "lightgray", // Set the color for empty stars
                },
              }}
            />
          </Box>
          <TextField
            label="Your Feedback"
            name="review"
            value={formData.review}
            onChange={handleChange}
            fullWidth
            margin="normal"
            placeholder="Enter your feedback"
            multiline
            rows={4} // Adjust the height of the text area
          />
          {/* <CustomEmojiPicker inputValue={formData.review} inputValueSetter={setFormData} /> */}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}
          >
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: "#FFB229",
              }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  </Box>
  
  );
};

export default FeedBackForm;
